import api from '@/services/Api';
import { ActionContext, Module } from 'vuex';
import { LaenderState, RootState } from '@/store/types';
import Land from '@/types/Land';
import { DataResponse } from '@/types';
import Postleitzahl from '@/types/Postleitzahl';

type Context = ActionContext<LaenderState, RootState>;

type LoadLaenderPayload = DataResponse<Partial<Land>[], {
    postleitzahlen: Postleitzahl[],
}>;

export const laender: Module<LaenderState, RootState> = {
    namespaced: true,
    state: {
        laender: [],
        postleitzahlen: [],
    },
    actions: {
        loadLaender({ commit }: Context): void {
            api.post('ivs/laender/load')
                .then((response) => commit('setLaender', response.data))
                .catch(console.error);
        },
    },
    mutations: {
        setLaender(state: LaenderState, payload: LoadLaenderPayload): void {
            state.laender = payload.body.map((land) => new Land(land));
            state.postleitzahlen = payload.selections.postleitzahlen.map((plz) => new Postleitzahl(plz));
        },
    },
};
